<template>
  <div class="grid-menu-config">
    <div style="padding: 0 6px;">
      <el-table :data="menuList" stripe>
        <el-table-column label="序列" prop="serialNumber" width="70"></el-table-column>
        <el-table-column label="菜单名称" prop="text"></el-table-column>
        <el-table-column label="菜单类型" prop="enumConstByFlagGridMenuType.name"></el-table-column>
        <el-table-column label="显示位置" prop="showType" width="100"></el-table-column>
        <el-table-column label="是否有效" prop="enumConstByFlagIsvalid.name" width="100"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="setMenuRoleScope(scope.row)" type="primary" size="mini">指定角色</el-button>
            <el-button @click="deleteSingleMenu(scope.row)" type="danger" size="mini">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column type="expand" fixed="left">
          <template slot-scope="props">
            <el-form size="mini" label-width="100px" label-position="left">
              <div style="width: 48%; float: left;">
                <el-form-item label="序列">
                  <el-input v-model.trim="props.row.serialNumber"></el-input>
                </el-form-item>
                <el-form-item label="菜单类型">
                  <el-select v-model="props.row.enumConstByFlagGridMenuType.id">
                    <el-option
                      v-for="op in menuTypeSelectData" :key="op.id" :value="op.id" :label="op.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="菜单名称">
                  <el-input v-model.trim="props.row.text"></el-input>
                </el-form-item>
                <el-form-item label="显示位置">
                  <el-radio v-model="props.row.showType" label="top" border>顶部</el-radio>
                  <el-radio v-model="props.row.showType" label="column" border>行内</el-radio>
                </el-form-item>
                <el-form-item label="行内位置">
                  <el-radio v-model="props.row.columnType" label="left" border>左侧</el-radio>
                  <el-radio v-model="props.row.columnType" label="right" border>右侧</el-radio>
                </el-form-item>
                <el-form-item label="是否冻结">
                  <el-switch v-model="props.row.fix" active-text="是" inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item label="dataIndex">
                  <el-input v-model.trim="props.row.dataIndex"></el-input>
                </el-form-item>
                <el-form-item label="nullText">
                  <el-input v-model.trim="props.row.nullText"></el-input>
                </el-form-item>
                <el-form-item label="userType">
                  <el-input v-model.trim="props.row.userType"></el-input>
                </el-form-item>
                <el-form-item label="是否有效">
                  <el-switch v-model="props.row.enumConstByFlagIsvalid.id"
                             active-text="是" inactive-text="否"
                             active-value="2" inactive-value="3"
                  ></el-switch>
                </el-form-item>
              </div>
              <div style="width: 48%; float: left; margin-left: 20px">
                <el-form-item label="是否必须选择记录">
                  <el-switch v-model="props.row.mustSelectRow" active-text="是" inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item label="单次操作的最大记录数">
                  <el-input v-model.trim="props.row.selectLimit"></el-input>
                </el-form-item>
                <el-form-item label="是否显示确认框">
                  <el-switch v-model="props.row.showConfirm" active-text="是" inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item label="确认框提示信息">
                  <el-input v-model.trim="props.row.confirmText"></el-input>
                </el-form-item>
                <el-form-item label="扩展配置">
                  <el-input v-model.trim="props.row.extendMenuConfig" type="textarea" :rows="3" resize="none" class="row_textarea"></el-input>
                </el-form-item>
                <el-form-item label="url"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'ajaxMenu' || menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'toUrlMenu'">
                  <el-input v-model.trim="props.row.url"></el-input>
                </el-form-item>
                <el-form-item label="补充参数"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'ajaxMenu' || menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'toUrlMenu'">
                  <el-input v-model.trim="props.row.extraParameters"></el-input>
                </el-form-item>
                <el-form-item label="waitingMsg"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'ajaxMenu'">
                  <el-input v-model.trim="props.row.waitingMsg"></el-input>
                </el-form-item>
                <el-form-item label="successMsg"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'ajaxMenu'">
                  <el-input v-model.trim="props.row.successMsg"></el-input>
                </el-form-item>
                <el-form-item label="errorMsg"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'ajaxMenu'">
                  <el-input v-model.trim="props.row.errorMsg"></el-input>
                </el-form-item>
                <el-form-item label="打开方式"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'toUrlMenu'">
                  <el-radio v-model="props.row.openMode" label="_self" border>当前窗口</el-radio>
                  <el-radio v-model="props.row.openMode" label="_blank" border>新窗口</el-radio>
                </el-form-item>
                <el-form-item label="要更新的列"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'updateColumnMenu'">
                  <el-input v-model.trim="props.row.column"></el-input>
                </el-form-item>
                <el-form-item label="更新列的值"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'updateColumnMenu'">
                  <el-input v-model.trim="props.row.value"></el-input>
                </el-form-item>
                <el-form-item label="提示信息"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'messageMenu'
                            || menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'formMenu'">
                  <el-input v-model.trim="props.row.tips"></el-input>
                </el-form-item>
                <el-form-item label="formConfig"
                              v-show="menuTypeMap[props.row.enumConstByFlagGridMenuType.id] === 'formMenu'">
                  <el-input v-model.trim="props.row.formConfig" type="textarea" :rows="3" resize="none" class="row_textarea"></el-input>
                </el-form-item>
              </div>
              <div style="clear: both;"></div>
              <el-form-item style="width: 100%;text-align: center;margin-top: 10px">
                <el-button @click="saveSingleMenu(props.row)" type="primary">保存</el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 6px; text-align: center;">
      <el-button @click="addMenu" type="primary" size="mini">新增菜单</el-button>
    </div>
    <menu-role-scope :menu="currentMenu" :webSites="webSites"></menu-role-scope>
  </div>
</template>

<script>
  import util from '../../libs/util'
  import MenuRoleScope from './menu-role-scope.vue'

  export default {
    components: {MenuRoleScope},
    name: 'grid-menu-config',
    props: {
      gridId: {
        type: String,
        require: true
      },
      webSites: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        currentMenu: {},
        menuList: [],
        menuTypeSelectData: [], // 菜单类型下拉框数据
        menuFormData: {}, // 菜单编辑form的数据模型
        menuTypeMap: {}
      }
    },
    computed: {},
    created() {
      this.loadMenuData()
      this.querymenuTypeSelectData()
    },
    mounted() {
    },
    methods: {
      loadMenuData() { // 加载菜单数据
        if (this.gridId) {
          let params = {gridId: this.gridId}
          util.ajax.post('/superAdmin/gridManage/queryGridMenuConfig', {params}).then((res) => {
            this.menuList = res.data.data
          }).catch((err) => {
            console.error(err)
          })
        }
      },
      querymenuTypeSelectData() { // 查询菜单类型
        let params = {namespace: 'FlagGridMenuType'}
        util.ajax.post('/superAdmin/gridManage/getEnumConstsByNamespace', {params}).then((res) => {
          this.menuTypeSelectData = res.data.data
          this.menuTypeSelectData.forEach(d => {
            this.menuTypeMap[d.id] = d.code
          })
        }).catch((err) => {
          console.error(err)
        })
      },
      saveSingleMenu(menu) { // 保存单个菜单
        if (!this.checkBeforeSaveMenu(menu)) {
          return
        }
        menu.gridBasicConfig = {id: this.gridId}
        menu.enumConstByFlagGridMenuType = {id: menu.enumConstByFlagGridMenuType.id}
        menu.enumConstByFlagIsvalid = {id: menu.enumConstByFlagIsvalid.id}
        util.ajax.post('/superAdmin/gridManage/saveSingleMenu', menu).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功'})
            let len = this.menuList.length
            this.menuList.splice(len - 1, 1)
            this.menuList.push(res.data.data)
            this.loadMenuData()
          } else {
            this.$notify.warning({title: '警告', message: '保存失败'})
          }
        }).catch((err) => {
          this.$notify.warning({title: '警告', message: '保存失败'})
          console.error(err)
        })
      },
      checkBeforeSaveMenu(menu) {
        if (!menu.enumConstByFlagGridMenuType || !menu.enumConstByFlagGridMenuType.id) {
          this.$notify.warning({title: '警告', message: '菜单类型不能为空'})
          return false
        }
        if (!menu.text) {
          this.$notify.warning({title: '警告', message: '菜单名称不能为空'})
          return false
        }
        if (!menu.dataIndex) {
          this.$notify.warning({title: '警告', message: 'dataIndex不能为空'})
          return false
        }
        if (!menu.enumConstByFlagIsvalid || !menu.enumConstByFlagIsvalid.id) {
          this.$notify.warning({title: '警告', message: '是否有效不能为空'})
          return false
        }
        if (menu.mustSelectRow === undefined) {
          this.$notify.warning({title: '警告', message: '是否必须选择记录不能为空'})
          return false
        }
        if (!menu.openMode) {
          this.$notify.warning({title: '警告', message: '打开方式不能为空'})
          return false
        }
        return true
      },
      addMenu() { // 新增按钮
        // 这里初始化的值一定要覆盖el-form绑定的属性,否则没有覆盖的属性赋值时会导致打开的form自动收起
        let defaultMenuConfig = {
          'id': '',
          'enumConstByFlagGridMenuType': {},
          'text': '自定义菜单',
          'showType': 'top',
          'columnType': 'left',
          'mustSelectRow': false,
          'fix': false,
          'selectLimit': 1,
          'dataIndex': 'id',
          'showConfirm': true,
          'openMode': '_blank',
          'enumConstByFlagIsvalid': {
            'id': '2',
            'name': '是'
          },
          'serialNumber': 1,
          tips: '',
          extendMenuConfig: '',
          nullText: '',
          userType: '',
          confirmText: '',
          waitingMsg: '',
          column: null,
          value: null,
          url: null,
          extraParameters: null,
          successMsg: null,
          errorMsg: null,
          formConfig: null
        }
        this.menuList.push(defaultMenuConfig)
      },
      deleteSingleMenu(menu) {
        this.$msgBox.showMsgBox({
          title: '提示',
          content: '确认删除菜单[' + menu.text + ']吗?',
          type: 'warning'
        }).then(() => {
          if (menu.id === '') {
            for (let i = 0; i < this.menuList.length; i++) {
              if (this.menuList[i].id === menu.id) {
                this.menuList.splice(i, 1)
                break
              }
            }
          } else {
            let params = {menuIds: menu.id}
            util.ajax.post('/superAdmin/gridManage/deleteGridMenu', {params}).then((res) => {
              if (res.data.meta.errCode === 0) {
                this.$notify.success({title: '成功', message: '删除成功'})
                for (let i = 0; i < this.menuList.length; i++) {
                  if (this.menuList[i].id === menu.id) {
                    this.menuList.splice(i, 1)
                    break
                  }
                }
              } else {
                this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
              }
            }).catch((err) => {
              this.$notify.warning({title: '警告', message: '删除失败'})
              console.error(err)
            })
          }
        }).catch(() => {
        })
      },
      setMenuRoleScope(menu) { // 设定按钮的角色范围
        if (!menu.id) {
          this.$notify.info({title: '提示', message: '菜单id不存在，无法设置角色范围'})
          return
        }
        this.currentMenu = {
          menuId: menu.id,
          menuName: menu.text
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/grid-manage/grid-menu-config.vue